import { DialogComponent } from './../../shared/ui/dialog/dialog.component';
import { InsertHyperlinkComponent } from './../../dialogs/insert-hyperlink/insert-hyperlink.component';
import { openDialog } from './../../store/actions/page.action';
import { Store } from '@ngrx/store';
import { ISelect } from './../../store/models/select.model';
import { ContentService } from 'app/store/services/content.service';
import { EContentGreeting, IContent } from './../../store/models/content.model';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { IReducers } from 'app/store/reducers';
import { UserService } from '../../store/services/user.service';
import { CampaignService } from '../../store/services/campaign.service';
import { EditorComponent } from '../../shared/ui/editor/editor.component';

@Component({
  selector: 'app-edit-content',
  templateUrl: './edit-content.component.html',
  styleUrls: ['./edit-content.component.scss'],
})
export class EditContentComponent implements OnInit {
  @ViewChild('editor', { read: EditorComponent }) editor: EditorComponent;
  contentId: number;
  contentInfo: IContent;
  formGroup: FormGroup;
  cancelButtonProperties: Button = {
    text: 'Cancel',
    color: ButtonColor.BLUE,
    route: ['/contents/content_group'],
    size: ButtonSize.SMALL,
  };
  greetings: ISelect<any> = {
    label: 'Select greeting',
    items: [
      {
        label: EContentGreeting.HI_FIRST_NAME,
        value: EContentGreeting.HI_FIRST_NAME,
      },
      {
        label: EContentGreeting.FIRST_NAME,
        value: EContentGreeting.FIRST_NAME,
      },
      {
        label: EContentGreeting.ALOHA,
        value: EContentGreeting.ALOHA,
      },
    ],
  };
  variables: any[] = [];
  commingFrom: string;
  submitButtonProperties: Button = {
    color: ButtonColor.ORANGE,
    text: 'Apply',
    size: ButtonSize.SMALL,
    onClick: () => {
      if (this.formGroup.valid) {
        const content = Object.assign({}, this.contentInfo);
        let doAll = false;

        content.content_attention = this.formGroup.get('attention').value;
        content.content_closing = this.formGroup.get('closing').value;
        content.content_details = this.formGroup.get('details').value;
        content.content_opening = this.formGroup.get('opening').value;
        content.content_sign = this.formGroup.get('signature').value;
        content.greeting = this.formGroup.get('greeting').value;
        content.subject = this.formGroup.get('subject').value;
        content.first_benefit = this.formGroup.get('benefit_01').value;
        content.second_benefit = this.formGroup.get('benefit_02').value;

        if (!content.content_sign.length) {
          this.store.dispatch(openDialog({
            dialogData: {
              content: '<div class="alert alert-warning"><p>There is no signature text added for that template. The system will append your default profile signature for that email. Do you want to proceed?</p></div>',
              title: 'Confirm about empty signature.',
              canClose: true,
              buttons: [
                {
                  text: 'Yes',
                  color: ButtonColor.GREEN,
                  size: ButtonSize.NORMAL,
                  onClick: (dialog) => {
                    dialog.closeDialog();
                    this.updateContent(content);
                  },
                },
              ],
            },
          }));
          return;
        }

        this.updateContent(content);
      }
    },
  };
  private groupName: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private contentService: ContentService,
    private store: Store<IReducers>,
    private router: Router,
    private readonly userService: UserService,
    private readonly campaignService: CampaignService,
  ) {
  }

  get signature(): AbstractControl {
    return this.formGroup.get('signature');
  }

  updateContent(content: IContent) {
    let doAll = false;
    if (
      this.formGroup.get('apply_greeting').value === true ||
      this.formGroup.get('apply_attention').value === true ||
      this.formGroup.get('apply_benefit_01').value === true ||
      this.formGroup.get('apply_benefit_02').value === true ||
      this.formGroup.get('apply_closing').value === true ||
      this.formGroup.get('apply_details').value === true ||
      this.formGroup.get('apply_subject').value === true ||
      this.formGroup.get('apply_opening').value === true ||
      this.formGroup.get('apply_signature').value === true
    ) {
      doAll = true;
    }

    if (doAll) {
      this.contentService.getContentsByGroupId(this.contentInfo.content_group_id,
      ).subscribe(response => {
        const items: any = response;

        for (const item of items) {
          if (item.content_id !== Number(this.contentId)) {
            const contentAll: IContent = Object.assign({}, item);

            if (this.formGroup.get('apply_subject').value === true) {
              contentAll.subject = this.formGroup.get('subject').value;
            }

            if (this.formGroup.get('apply_greeting').value === true) {
              contentAll.greeting = this.formGroup.get('greeting').value;
            }

            if (this.formGroup.get('apply_attention').value === true) {
              contentAll.content_attention =
                this.formGroup.get('attention').value;
            }
            if (this.formGroup.get('apply_opening').value === true) {
              contentAll.content_opening =
                this.formGroup.get('opening').value;
            }

            if (this.formGroup.get('apply_benefit_01').value === true) {
              doAll = true;
              contentAll.first_benefit =
                this.formGroup.get('benefit_01').value;
            }

            if (this.formGroup.get('apply_benefit_02').value === true) {
              doAll = true;
              contentAll.second_benefit =
                this.formGroup.get('benefit_02').value;
            }

            if (this.formGroup.get('apply_closing').value === true) {
              doAll = true;
              contentAll.content_closing =
                this.formGroup.get('closing').value;
            }

            if (this.formGroup.get('apply_signature').value === true) {
              doAll = true;
              contentAll.content_sign = this.formGroup.get('signature').value;
            }

            if (this.formGroup.get('apply_details').value === true) {
              doAll = true;
              contentAll.content_details =
                this.formGroup.get('details').value;
            }

            this.contentService
              .updateContent(item.content_id, contentAll)
              .subscribe(result => {
              });
          } else {
            this.contentService
              .updateContent(this.contentId, content)
              .subscribe(result => {
                if (result && result.content_id) {
                }
              });
          }
        }

        this.router.navigate(['/contents', this.contentId, 'preview', {
          group_name: this.groupName,
        }]);
      });
    } else {
      this.contentService
        .updateContent(this.contentId, content)
        .subscribe(result => {
          if (result && result.content_id) {
            this.router.navigate(['/contents', this.contentId, 'preview', {
              group_name: this.groupName,
            }]);
          }
        });
    }
  }

  onGreetingsSelection = value => {
    this.formGroup.get('greeting').setValue(value);
  };

  ngOnInit() {
    this.contentId = this.activatedRoute.snapshot.params.id;
    this.commingFrom = this.activatedRoute.snapshot.params.from;
    this.groupName = this.activatedRoute.snapshot.params.group_name;

    if (this.commingFrom && this.commingFrom.length !== 0) {
      if (this.commingFrom === 'preview') {
        this.cancelButtonProperties.route = ['/contents', this.contentId, 'preview', {
          group_name: this.groupName,
        }];
      }
    }
    this.userService.getLabels().subscribe(response => {
      const vars = [];
      vars.push({ label: '------', value: '' });
      if (response) {
        if (response.label1 !== '') {
          vars.push({
            label: response.label1,
            value: response.label1,
          });
        }

        if (response.label2 !== '') {
          vars.push({
            label: response.label2,
            value: response.label2,
          });
        }

        if (response.label3 !== '') {
          vars.push({
            label: response.label3,
            value: response.label3,
          });
        }

        if (vars.length > 1) {
          this.variables = vars;
        }
      }
    });
    this.contentService
      .getContentInfo(this.contentId)
      .subscribe((result: IContent) => {
        this.formGroup = new FormGroup({
          subject: new FormControl(result.subject, [Validators.required]),
          apply_subject: new FormControl(false),
          custom_greeting: new FormControl(),
          greeting: new FormControl(result.greeting),
          apply_greeting: new FormControl(false),
          attention: new FormControl(result.content_attention),
          apply_attention: new FormControl(false),
          benefit_01: new FormControl(result.first_benefit),
          apply_benefit_01: new FormControl(false),
          benefit_02: new FormControl(result.second_benefit),
          apply_benefit_02: new FormControl(false),
          closing: new FormControl(result.content_closing),
          apply_closing: new FormControl(false),
          signature: new FormControl(result.content_sign ? result.content_sign.replace(new RegExp('\r\n', 'g'), '</br>') : ''),
          apply_signature: new FormControl(false),
          details: new FormControl(result.content_details),
          apply_details: new FormControl(false),
          opening: new FormControl(result.content_opening),
          apply_opening: new FormControl(false),
        });

        this.contentInfo = result;
      });
  }

  insertHyperlink(controlName: string) {
    this.store.dispatch(
      openDialog({
        dialogData: {
          content: InsertHyperlinkComponent,
          title: 'Insert Hyperlink',
          canClose: true,
          dialogMinWidth: '700px',
          buttons: [
            {
              color: ButtonColor.BLUE,
              size: ButtonSize.SMALL,
              text: 'Insert Link',
              actAsClose: true,
              onClick: (dialog: DialogComponent) => {
                if (dialog.dialogForm.valid) {
                  const anchor = `<a href='${
                    dialog.dialogForm.get('url').value
                  }' target='${dialog.dialogForm.get('target').value}'>${
                    dialog.dialogForm.get('content').value
                  }</a>`;
                  this.insertLink(anchor, controlName);
                }
              },
            },
          ],
        },
      }),
    );
  }

  onEditorInit() {
    this.formGroup.get('signature').setValue(this.contentInfo?.content_sign ? this.contentInfo.content_sign.replace(new RegExp('\r\n', 'g'), '<br>') : '');
  }

  onVariableSelect($event: string, editorOpening: EditorComponent) {
    editorOpening.insertContent($event);
  }

  private insertLink(linkContent: string, controlName: string) {
    const elementRef: ElementRef = this[controlName];

    if (!elementRef) {
      return false;
    }

    const cursorPosition = elementRef.nativeElement.selectionStart;
    const prevValue = this.formGroup.get(controlName).value;
    const leftString = prevValue.substr(0, cursorPosition);
    const rightString = prevValue.substr(cursorPosition);

    this.formGroup
      .get(controlName)
      .setValue(leftString + linkContent + rightString);
  }
}
